import { FORGOT_PASSWORD_PREFIX, REGISTER_PREFIX } from 'constants/router';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ButtonCommon from '../../common/ButtonCommon';

const FormLogInMobile = ({
  renderFormInputValidations,
  handleSubmit,
  onForgotPassword,
}) => {
  const { t } = useLang();
  const navigate = useNavigate();

  const handleForgotPassword = () => {
    onForgotPassword();
    navigate(FORGOT_PASSWORD_PREFIX);
  };

  return (
    <FormLogInMobileStyled>
      {renderFormInputValidations()}
      {onForgotPassword ? (
        <ForgotPasswordButton onClick={handleForgotPassword}>
          {t('button_forgot_password')}
        </ForgotPasswordButton>
      ) : (
        <LinkForgotPasswordStyled to={FORGOT_PASSWORD_PREFIX}>
          {t('button_forgot_password')}
        </LinkForgotPasswordStyled>
      )}
      <Register>
        {t('login_text_no_account')}{' '}
        <LinkRegisterStyled to={REGISTER_PREFIX}>
          {t('button_register_now')}
        </LinkRegisterStyled>
      </Register>
      <RegisterSubmit>
        <ButtonCommon
          value={t('button_login')}
          onClick={handleSubmit}
          styles={{
            margin: '0px',
            width: '100%',
          }}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          isUseKeyDown={true}
          isUseKeyDownException={true}
        />
      </RegisterSubmit>
    </FormLogInMobileStyled>
  );
};

const FormLogInMobileStyled = styled(Form)`
  position: relative;
  width: 100%;
  height: fit-content;
  padding-bottom: 180px;
`;

const LinkForgotPasswordStyled = styled(Link)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  text-decoration: none;

  color: #002ff1;
  display: block;
  margin-top: 16px;

  &:hover {
    color: var(--ds-c-blue) !important;
  }
`;

const LinkRegisterStyled = styled(Link)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;

  color: var(--bg-primary);

  &:hover {
    color: var(--bg-primary-hover);
  }
`;

const RegisterSubmit = styled.div`
  position: fixed;
  bottom: 0px;
  background: var(--ds-c-white);
  width: 100%;
  margin-inline: -24px;
  padding: 16px 24px;
  border-top: 1px solid var(--ds-c-grey-disabled);
`;

const Register = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;

  color: var(--ds-c-grey-dark);
  margin-bottom: 0px;
  position: fixed;
  bottom: 76px;
  left: 24px;
  width: 100%;
  height: 44px;
  background: #fff;
`;

const ForgotPasswordButton = styled.button`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  color: #002ff1;
  display: block;
  margin-top: 16px;

  &:hover {
    color: var(--ds-c-blue) !important;
  }
`;

export default FormLogInMobile;
